export const TOOLTIP_DESCRIPTION = 'If there is more than one individual included, upload a separate table that lists the names of and payments to each as part of your Payroll Documents located after step 6 of the application process.';
export const TOOLTIP_NAME = 'number-of-owners-tooltip';
